import { Storage } from "aws-amplify";

async function getActiveRoute(root) {
  try {
    const url = await Storage.get(root + "/active_route.txt", {
      customPrefix: {
        public: "",
      },
    });
    const result = await fetch(url);
    return result.text().then((route_type) => {
      return route_type;
    });
  } catch (e) {
    throw new Error(`Could not retrieve file from S3: ${e.message}`);
  }
}

async function getRoute(root) {
  try {
    const routeType = await getActiveRoute(root);
    const url = await Storage.get(root + "/" + routeType + ".json", {
      customPrefix: {
        public: "",
      },
    });
    const result = await fetch(url);
    return result.json().then((route) => {
      return route;
    });
  } catch (e) {
    throw new Error(`Could not retrieve file from S3: ${e.message}`);
  }
}

export default getRoute;
